var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelGoogleplusFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  x: 3,
  y: 3,
  fill: "#DD4B39",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M9.811 8.25c.988 0 1.888.376 2.565.992-.798.753-.771.798-1.085 1.111-.392-.323-.819-.556-1.48-.556-1.25 0-2.226 1.014-2.226 2.264s.976 2.264 2.226 2.264c1.236 0 1.738-.532 2.06-1.51l-2.06.001v-1.51h3.66c.256 1.827-.513 4.567-3.66 4.567a3.811 3.811 0 0 1 0-7.623m7.096 2.178v1.09H18v1.104h-1.093v1.072h-1.072v-1.072h-1.108v-1.104h1.108v-1.09z"
}))));
export default SvgGemChannelGoogleplusFilled;